import React, { useEffect, useState, useRef } from "react"
import "./AddInstitution.scss"
import InstituteApi from "Api/InstituteApi"
import * as Yup from "yup"
import { useNavigate, useLocation } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import Country from "../../../utils/Data/Country"
import { Dropdown } from "primereact/dropdown"

import { Calendar } from "primereact/calendar"
import { Toast } from "primereact/toast"
import S3UploadApi from "Api/s3Upload"
import CourseApi from "Api/CourseApi"

const AddInstitution = () => {
  document.title = "Add Institution"
  const [loading, setLoading] = useState(false)
  const toast = useRef(null)
  const navigate = useNavigate("")
  const location = useLocation()
  const accessToken = localStorage.getItem("accessToken")

  // Get the category from navigation state
  const initialCategory = location.state?.type
    ? {
        name: location.state.type,
        code: location.state.type,
      }
    : null

  const insituteInitialData = {
    institutionName: "",
    university: "",
    category: initialCategory,
    displayName: "",
    type: "",
    yearEstablished: "",
    country: "",
    state: "",
    city: "",
    pinCode: null,
    address: "",
    campusSize: "",
    noOfStudents: null,
    noOfDepartments: "",
    noOfCourses: "",
    totalFaculty: "",
    officialWebsite: "",
    nirfRanking: "",
    indiaToday2023Ranking: "",
    timesRanking2024: null,
    email: "",
    ugcApproval: "",
    aiuAffiliation: "",
    highlights: "",
    aboutContent: "",
    description: "",  
    logo: {
      url: "",
      alt: "",
    },
    qsRanking: "",
    cutoffs: [],
    bannerImage: {
      url: "",
      alt: "",
    },
    gallery: [],
    beddedHospital: "",
    yearlyIntake: "",
    batch: "",
    brochure: "",
    fees: "",
    nriFees: "",
    hostelFees: "",
    priceRange: "",
    topPick: "",
    neetYear: "",
    // bdsYearlyIntake: "",
    pixwikShow: { name: "No", code: "No" },
  }

  const [institutionData, setInstitutionData] = useState(insituteInitialData)

  const handleInstitutionDataChange = (name, value) => {
    setInstitutionData({ ...institutionData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const [universityData, setUniversityData] = useState([])

  const getUniversityMenu = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {})
  }

  const [courseData, setCourseData] = useState([])

  const getCourseList = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    CourseApi.getAllCourse(config)
      .then(res => {
        if (res.data.status) {
          const formattedCourses = res.data.Course.map(course => ({
            name: course.courseName,
            code: course._id,
            originalCourse: course,
          }))
          console.log(formattedCourses)
          setCourseData(formattedCourses)
        }
      })
      .catch(err => {
        console.error("Error fetching courses:", err)
        setCourseData([])
      })
  }

  useEffect(() => {
    getUniversityMenu()
    getCourseList()
  }, [accessToken])

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Institution", link: "/institutionList" },
    { label: "Add Institution", link: "/addInstitution" },
  ]
  const handleBreadcrumbClick = link => {
    navigate(link)
  }

  const typeOptions = [
    { name: "Private", code: "private" },
    { name: "Government", code: "government" },
    { name: "Autonomous", code: "autonomous" },
  ]
  const categoryOptions = [
    { name: "Medical", code: "medical" },
    { name: "Engineering", code: "engineering" },
    { name: "Arts & Science", code: "artsAndScience" },
    { name: "Agriculture", code: "agriculture" },
    { name: "Law", code: "law" },
    { name: "Management", code: "management" }
  ]

  const univerSiytOptions = universityData?.map(university => ({
    name: university.universityName,
    code: university.universityCode,
  }))

  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const [errors, setErrors] = useState({})

  const ValidateInstitution = Yup.object().shape({
    institutionName: Yup.string().required("Institution name is required"),
    displayName: Yup.string().required("Display name is required"),
    type: Yup.string().required("Type is required"),
    category: Yup.string().required("Category is required"),
    country: Yup.string().required("Country is required"),
    university: Yup.string().required("University is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string().required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
    logo: Yup.object().shape({
      url: Yup.string().required("Logo is required"),
      alt: Yup.string()
    }),
    gallery: Yup.array().min(1, "At least one gallery image is required"),
    // Medical college specific fields
    beddedHospital: Yup.string().when("category", {
      is: "medical",
      then: Yup.string().required("Bedded Hospital is required for medical colleges"),
      otherwise: Yup.string()
    }),
    yearlyIntake: Yup.string().when("category", {
      is: "medical",
      then: Yup.string().required("Yearly Intake is required for medical colleges"),
      otherwise: Yup.string()
    }),
    batch: Yup.string().when("category", {
      is: "medical",
      then: Yup.string().required("Batch is required for medical colleges"),
      otherwise: Yup.string()
    }),
    neetYear: Yup.string().when("category", {
      is: "medical",
      then: Yup.string().required("NEET Year is required for medical colleges"),
      otherwise: Yup.string()
    })
  })

  const [logoFile, setLogoFile] = useState(null)
  const [logoUrl, setLogoUrl] = useState("")
  const [isUploading, setIsUploading] = useState(false)
  const [galleryFiles, setGalleryFiles] = useState([])
  const [galleryUrls, setGalleryUrls] = useState([])
  const [galleryAltTexts, setGalleryAltTexts] = useState([])
  const [isUploadingGallery, setIsUploadingGallery] = useState(false)
  const [bannerFile, setBannerFile] = useState(null)
  const [bannerUrl, setBannerUrl] = useState("")
  const [isUploadingBanner, setIsUploadingBanner] = useState(false)
  const [brochureFile, setBrochureFile] = useState(null)
  const [isUploadingBrochure, setIsUploadingBrochure] = useState(false)

  const handleLogoChange = e => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0])
      setLogoUrl("")
    }
  }

  const uploadLogo = async () => {
    if (!logoFile) return null

    setIsUploading(true)
    try {
      const formData = new FormData()
      formData.append("image", logoFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newLogoUrl = response.data.imageUrl

      setLogoUrl(newLogoUrl)
      handleInstitutionDataChange("logo", {
        url: newLogoUrl,
        alt: institutionData.logo?.alt || "",
      })
      setLogoFile(null)
      setIsUploading(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Logo uploaded successfully",
        life: 3000,
      })
      return newLogoUrl
    } catch (error) {
      console.error("Error uploading logo:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading logo",
        life: 3000,
      })
      setIsUploading(false)
      return null
    }
  }

  const handleGalleryChange = e => {
    if (e.target.files) {
      setGalleryFiles([...galleryFiles, ...Array.from(e.target.files)])
    }
  }

  const handleGalleryAltTextChange = (index, value) => {
    const newAltTexts = [...galleryAltTexts]
    newAltTexts[index] = value
    setGalleryAltTexts(newAltTexts)

    // Update the gallery data in institutionData
    const updatedGallery = galleryUrls.map((url, i) => ({
      url,
      alt: newAltTexts[i] || "",
    }))
    handleInstitutionDataChange("gallery", updatedGallery)
  }

  const uploadGalleryImages = async () => {
    if (galleryFiles.length === 0) return

    setIsUploadingGallery(true)
    try {
      const uploadPromises = galleryFiles.map(async file => {
        const formData = new FormData()
        formData.append("image", file)

        const response = await S3UploadApi.uploadImage(formData)
        return response.data.imageUrl
      })

      const newUrls = await Promise.all(uploadPromises)
      const newAltTexts = newUrls.map(() => "") // Initialize empty alt texts for new images

      setGalleryUrls([...galleryUrls, ...newUrls])
      setGalleryAltTexts([...galleryAltTexts, ...newAltTexts])
      setGalleryFiles([])
      setIsUploadingGallery(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Gallery images uploaded successfully",
        life: 3000,
      })
    } catch (error) {
      console.error("Error uploading gallery images:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading gallery images",
        life: 3000,
      })
      setIsUploadingGallery(false)
    }
  }

  const removeGalleryImage = async indexToRemove => {
    const imageUrl = galleryUrls[indexToRemove]
    const success = await deleteImage(imageUrl)
    if (success) {
      setGalleryUrls(galleryUrls.filter((_, index) => index !== indexToRemove))
      setGalleryAltTexts(
        galleryAltTexts.filter((_, index) => index !== indexToRemove),
      )

      // Update the gallery data in institutionData
      const updatedGallery = galleryUrls
        .filter((_, index) => index !== indexToRemove)
        .map((url, i) => ({
          url,
          alt: galleryAltTexts[i] || "",
        }))
      handleInstitutionDataChange("gallery", updatedGallery)
    }
  }

  const removeSelectedFile = indexToRemove => {
    setGalleryFiles(galleryFiles.filter((_, index) => index !== indexToRemove))
  }

  const handleBannerChange = e => {
    if (e.target.files && e.target.files[0]) {
      setBannerFile(e.target.files[0])
      setBannerUrl("")
    }
  }

  const uploadBanner = async () => {
    if (!bannerFile) return null

    setIsUploadingBanner(true)
    try {
      const formData = new FormData()
      formData.append("image", bannerFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBannerUrl = response.data.imageUrl

      setBannerUrl(newBannerUrl)
      handleInstitutionDataChange("bannerImage", {
        url: newBannerUrl,
        alt: institutionData.bannerImage?.alt || "",
      })
      setBannerFile(null)
      setIsUploadingBanner(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Banner uploaded successfully",
        life: 3000,
      })
      return newBannerUrl
    } catch (error) {
      console.error("Error uploading banner:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading banner",
        life: 3000,
      })
      setIsUploadingBanner(false)
      return null
    }
  }

  const uploadBrochure = async () => {
    if (!brochureFile) return

    setIsUploadingBrochure(true)
    try {
      const formData = new FormData()
      formData.append("image", brochureFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBrochureUrl = response.data.imageUrl

      setInstitutionData(prev => ({
        ...prev,
        brochure: newBrochureUrl,
      }))
      setBrochureFile(null)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Brochure uploaded successfully",
        life: 3000,
      })
    } catch (error) {
      console.error("Error uploading brochure:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading brochure",
        life: 3000,
      })
    } finally {
      setIsUploadingBrochure(false)
    }
  }

  const handleBrochureDelete = async () => {
    if (institutionData.brochure) {
      const success = await deleteImage(institutionData.brochure)
      if (success) {
        setInstitutionData(prev => ({
          ...prev,
          brochure: "",
        }))
      }
    }
  }

  const addInstitute = async () => {
    try {
      setLoading(true)

      // Upload logo first if needed
      if (logoFile && !logoUrl) {
        const uploadedLogoUrl = await uploadLogo()
        if (!uploadedLogoUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to upload logo. Please try uploading again before adding.",
            life: 3000,
          })
          setLoading(false)
          return
        }
      }

      // Upload banner first if needed
      if (bannerFile && !bannerUrl) {
        const uploadedBannerUrl = await uploadBanner()
        if (!uploadedBannerUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to upload banner. Please try uploading again before adding.",
            life: 3000,
          })
          setLoading(false)
          return
        }
      }

      // Format category code properly
      let categoryCode = institutionData?.category?.code
      // if (categoryCode === "artsAndScience") {
      //   categoryCode = "artsAndScience"
      // } else {
      //   categoryCode = categoryCode?.toLowerCase()
      // }

      const payload = {
        ...institutionData,
        gallery: galleryUrls.map((url, i) => ({
          url,
          alt: galleryAltTexts[i] || "",
        })),
        country: institutionData?.country?.name,
        type: institutionData?.type?.code?.toLowerCase(),
        category: categoryCode,
        university: institutionData?.university?.code,
        institutionName: institutionData?.institutionName,
        aiuAffiliation: institutionData?.aiuAffiliation?.name === "Yes",
        ugcApproval: institutionData?.ugcApproval?.name === "Yes",
        pixwikShow: institutionData?.pixwikShow?.name === "Yes",
        topPick: institutionData?.topPick?.name === "Yes",
        logo: {
          url: logoUrl,
          alt: institutionData.logo?.alt || "",
        },
        bannerImage: {
          url: bannerUrl,
          alt: institutionData.bannerImage?.alt || "",
        }
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      const response = await InstituteApi.addInstitution(payload, config)

      if (response.data.status) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.data.message,
          life: 3000,
        })
        setTimeout(() => {
          navigate("/institutionList")
        }, 1000)
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.data.message,
          life: 3000,
        })
      }
    } catch (error) {
      console.error("Error in addInstitute:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "An unexpected error occurred",
        life: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  // const handleAddReview = () => {
  //   if (!currentReview.name || !currentReview.review) {
  //     toast.current.show({
  //       severity: 'error',
  //       summary: 'Error',
  //       detail: 'Both name and review are required',
  //       life: 3000
  //     });
  //     return;
  //   }

  //   // Add the new review to the reviews array
  //   const updatedReviews = [...institutionData.reviews, currentReview];
  //   handleInstitutionDataChange("reviews", updatedReviews);

  //   // Clear the input fields
  //   setCurrentReview({ name: "", review: "" });

  //   toast.current.show({
  //     severity: 'success',
  //     summary: 'Success',
  //     detail: 'Review added successfully',
  //     life: 3000
  //   });
  // };

  // const handleRemoveReview = (index) => {
  //   const updatedReviews = institutionData.reviews.filter((_, i) => i !== index);
  //   handleInstitutionDataChange("reviews", updatedReviews);
  // };

  // Add this after other useState declarations
  const [currentReview, setCurrentReview] = useState({
    name: "",
    review: "",
  })

  // Add these after other useState declarations
  const [currentCutoff, setCurrentCutoff] = useState({
    course: "",
    year: "",
    quota: "",
    rounds: {
      round1: "TBA",
      round2: "TBA",
      mopUpRound: "TBA",
      strayVacancy: "TBA",
    },
  })

  // Add quota options
  const quotaOptions = [
    { name: "OC", code: "OC" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
  ]

  // Update handleAddCutoff function
  const handleAddCutoff = () => {
    if (!currentCutoff.course || !currentCutoff.year || !currentCutoff.quota) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Course, Year and Quota are required",
        life: 3000,
      })
      return
    }

    // Create cutoff object with course ID
    const newCutoff = {
      course: currentCutoff.course.code, // Store just the course code
      year: currentCutoff.year,
      quota: currentCutoff.quota.code || currentCutoff.quota, // Store the quota code
      rounds: {
        round1: currentCutoff.rounds.round1,
        round2: currentCutoff.rounds.round2,
        mopUpRound: currentCutoff.rounds.mopUpRound,
        strayVacancy: currentCutoff.rounds.strayVacancy,
      },
    }

    const updatedCutoffs = [...institutionData.cutoffs, newCutoff]
    handleInstitutionDataChange("cutoffs", updatedCutoffs)

    // Reset the form
    setCurrentCutoff({
      course: "",
      year: "",
      quota: "",
      rounds: {
        round1: "TBA",
        round2: "TBA",
        mopUpRound: "TBA",
        strayVacancy: "TBA",
      },
    })

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Cutoff added successfully",
      life: 3000,
    })
  }

  const handleRemoveCutoff = index => {
    const updatedCutoffs = institutionData.cutoffs.filter((_, i) => i !== index)
    handleInstitutionDataChange("cutoffs", updatedCutoffs)
  }

  // Add these functions after the existing state declarations
  const deleteImage = async imageUrl => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      // Send the complete URL instead of just the ID
      await S3UploadApi.deleteImage({ fileUrl: imageUrl }, config)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Image deleted successfully",
        life: 3000,
      })
      return true
    } catch (error) {
      console.error("Error deleting image:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete image",
        life: 3000,
      })
      return false
    }
  }

  // Update logo handling
  const handleLogoDelete = async () => {
    if (logoUrl) {
      const success = await deleteImage(logoUrl)
      if (success) {
        setLogoUrl("")
        handleInstitutionDataChange("logo", "")
      }
    }
  }

  // Update banner handling
  const handleBannerDelete = async () => {
    if (bannerUrl) {
      const success = await deleteImage(bannerUrl)
      if (success) {
        setBannerUrl("")
        handleInstitutionDataChange("bannerImage", "")
      }
    }
  }

  return (
    <div className="add-institution">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle={`Add Institution -  ${initialCategory?.name} `}
              handleBreadcrumbClick={handleBreadcrumbClick}
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="institution-add-form ">
                <div className="institution-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.university}
                      onChange={e => {
                        handleInstitutionDataChange("university", e.value)
                      }}
                      options={univerSiytOptions}
                      optionLabel="name"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="institutionName">
                    Institution Name <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="institutionName"
                      value={institutionData.institutionName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "institutionName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Institution Name"
                    />
                    {errors.institutionName && (
                      <small className="error">{errors.institutionName}</small>
                    )}
                  </div>

                  {/* <Dropdown
            id="institutionName"
            value={institutionData.institutionName}
            onChange={(e) =>
              handleInstitutionDataChange("institutionName", e.value)
            }
            options={institueOptions}
            optionLabel="name"
            placeholder="Select Institution"
            filter
            editable
          /> */}
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="displayName">
                    Display Name <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={institutionData.displayName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="category">Category</label>
                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.category}
                      onChange={e =>
                        handleInstitutionDataChange("category", e.value)
                      }
                      options={categoryOptions}
                      optionLabel="name"
                      placeholder="Select Category"
                      filter
                    />
                    {errors.category && (
                      <small className="error">{errors.category}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="type">
                    Type <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.type}
                      onChange={e =>
                        handleInstitutionDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                    />
                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="yearEstablished">Year Established </label>

                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        institutionData.yearEstablished
                          ? new Date(institutionData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleInstitutionDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select Year Established"
                    />

                    {errors.yearEstablished && (
                      <small className="error">{errors.yearEstablished}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="country">
                    Country <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={institutionData.country}
                      onChange={e =>
                        handleInstitutionDataChange("country", e.value)
                      }
                      options={Country}
                      // itemTemplate={countryOptionTemplate}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="state">
                    State <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={institutionData.state}
                      onChange={e =>
                        handleInstitutionDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="username">
                    City <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={institutionData.city}
                      onChange={e =>
                        handleInstitutionDataChange("city", e.target.value)
                      }
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="pinCode">
                    PinCode <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={institutionData.pinCode}
                      onChange={e =>
                        handleInstitutionDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter PinCode"
                    />
                    {errors.pinCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="address">
                    Address <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={institutionData.address}
                      onChange={e =>
                        handleInstitutionDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                    />
                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>
                {/* <div className="institution-add-inp">
                  <label htmlFor="phoneNumber">Phone</label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={institutionData.country}
                        // onChange={e =>
                        //   handleInstitutionDataChange("phoneCode", e.value)
                        // }
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={institutionData.phone}
                        onChange={e =>
                          handleInstitutionDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="institution-add-inp">
                  <label htmlFor="email">Email</label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={institutionData.email}
                      onChange={e =>
                        handleInstitutionDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="officialWebsite">Official Website</label>

                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={institutionData.officialWebsite}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "officialWebsite",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Official Website"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="campusSize">Campus Size</label>

                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={institutionData.campusSize}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "campusSize",
                          e.target.value,
                        )
                      }
                      placeholder="Enter CampusSize"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfStudents"> No Of Students</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfStudents"
                      value={institutionData.noOfStudents}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfStudents",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Students"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfDepartments"> No Of Departments</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={institutionData.noOfDepartments}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfCourses"> No Of Courses</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={institutionData.noOfCourses}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="totalFaculty"> Total Faculty</label>

                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={institutionData.totalFaculty}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="nirfRanking"> NIRF Ranking</label>

                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={institutionData.nirfRanking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="indiaToday2023Ranking">
                    {" "}
                    IndiaToday 2023 Ranking
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={institutionData.indiaToday2023Ranking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter IndiaToday 2023 Ranking"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="timesRanking2024"> Times Ranking 2024</label>

                  <div className="inp-err">
                    <InputText
                      id="timesRanking2024"
                      value={institutionData.timesRanking2024}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "timesRanking2024",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Times Ranking 2024"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="qsRanking"> QS Ranking</label>

                  <div className="inp-err">
                    <InputText
                      id="qsRanking"
                      value={institutionData.qsRanking}
                      onChange={e =>
                        handleInstitutionDataChange("qsRanking", e.target.value)
                      }
                      placeholder="Enter QS Ranking"
                    />
                    {errors.qsRanking && (
                      <small className="error">{errors.qsRanking}</small>
                    )}
                  </div>
                </div>
                {institutionData.category &&
                  institutionData.category.code.toLowerCase() === "medical" && (
                    <>
                      <div className="institution-add-inp">
                        <label htmlFor="fees">Fees</label>
                        <div className="inp-err">
                          <InputText
                            id="fees"
                            value={institutionData.fees}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "fees",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Fees"
                          />
                          {errors.fees && (
                            <small className="error">{errors.fees}</small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="nriFees">NRI Fees</label>
                        <div className="inp-err">
                          <InputText
                            id="nriFees"
                            value={institutionData.nriFees}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "nriFees",
                                e.target.value,
                              )
                            }
                            placeholder="Enter NRI Fees"
                          />
                          {errors.nriFees && (
                            <small className="error">{errors.nriFees}</small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="hostelFees">Hostel Fees</label>
                        <div className="inp-err">
                          <InputText
                            id="hostelFees"
                            value={institutionData.hostelFees}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "hostelFees",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Hostel Fees"
                          />
                          {errors.hostelFees && (
                            <small className="error">{errors.hostelFees}</small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="priceRange">Price Range</label>
                        <div className="inp-err">
                          <InputText
                            id="priceRange"
                            value={institutionData.priceRange}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "priceRange",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Price Range"
                          />
                          {errors.priceRange && (
                            <small className="error">{errors.priceRange}</small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="neetYear">NEET Year</label>
                        <div className="inp-err">
                          <Calendar
                            id="neetYear"
                            value={
                              institutionData.neetYear
                                ? new Date(institutionData.neetYear, 0)
                                : null
                            }
                            onChange={e => {
                              const selectedYear = e.value
                                ? new Date(e.value).getFullYear()
                                : null
                              handleInstitutionDataChange(
                                "neetYear",
                                selectedYear,
                              )
                            }}
                            view="year"
                            dateFormat="yy"
                            placeholder="Select NEET Year"
                            className="inp-field-box"
                          />
                          {errors.neetYear && (
                             <small className="error">{errors.neetYear}</small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="topPick" className="label">
                          Top Pick
                        </label>
                        <div className="inp-err ">
                          <Dropdown
                            value={institutionData.topPick}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "topPick",
                                e.value,
                              )
                            }
                            options={approvalOptions}
                            optionLabel="name"
                            placeholder="Select Top Pick"
                            className="inp-field-box"
                          />
                          {errors.topPick && (
                            <small className="error">{errors.topPick}</small>
                          )}
                        </div>
                      </div>

                      <div className="institution-add-inp">
                        <label htmlFor="beddedHospital">Bedded Hospital</label>
                        <div className="inp-err">
                          <InputText
                            id="beddedHospital"
                            value={institutionData.beddedHospital}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "beddedHospital",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Bedded Hospital"
                          />
                          {errors.beddedHospital && (
                            <small className="error">
                              {errors.beddedHospital}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="institution-add-inp">
                        <label htmlFor="yearlyIntake">Yearly Intake</label>
                        <div className="inp-err">
                          <InputText
                            id="yearlyIntake"
                            value={institutionData.yearlyIntake}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "yearlyIntake",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Yearly Intake"
                          />
                          {errors.yearlyIntake && (
                            <small className="error">
                              {errors.yearlyIntake}
                            </small>
                          )}
                        </div>
                      </div>
                      {/* <div className="institution-add-inp">
                        <label htmlFor="bdsYearlyIntake">BDS Yearly Intake</label>
                        <div className="inp-err">
                          <InputText
                            id="bdsYearlyIntake"
                            value={institutionData.bdsYearlyIntake}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "bdsYearlyIntake",
                                e.target.value,
                              )
                            }
                            placeholder="Enter BDS Yearly Intake"
                          />
                          {errors.bdsYearlyIntake && (
                            <small className="error">
                              {errors.bdsYearlyIntake}
                            </small>
                          )}
                        </div>
                      </div> */}
                      <div className="institution-add-inp">
                        <label htmlFor="batch">Batch</label>
                        <div className="inp-err">
                          <InputText
                            id="batch"
                            value={institutionData.batch}
                            onChange={e =>
                              handleInstitutionDataChange(
                                "batch",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Batch"
                          />
                          {errors.batch && (
                            <small className="error">{errors.batch}</small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                <div className="institution-add-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={institutionData.ugcApproval}
                      onChange={e =>
                        handleInstitutionDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.aiuAffiliation}
                      onChange={e =>
                        handleInstitutionDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="pixwikShow" className="label">
                    Pixwik Show
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.pixwikShow}
                      onChange={e =>
                        handleInstitutionDataChange("pixwikShow", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select Pixwik Show"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="highlights">
                    Highlights <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={institutionData.highlights}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "highlights",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Highlights"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="aboutContent">
                    About Content <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={institutionData.aboutContent}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.aboutContent}</small>
                    )}
                  </div>
                </div>

                {institutionData.category &&
                  institutionData.category.code.toLowerCase() === "medical" && (
                    <div className="institution-add-inp">
                      <label htmlFor="description">
                        Description <small className="text-danger"> *</small>
                      </label>

                      <div className="inp-err">
                        <InputText
                          id="description"
                          value={institutionData.description}
                          onChange={e =>
                            handleInstitutionDataChange(
                              "description",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Description"
                        />
                        {errors.description && (
                          <small className="error">{errors.description}</small>
                        )}
                      </div>
                    </div>
                  )}

                <div className="institution-add-inp">
                  <label htmlFor="brochure">Brochure</label>
                  <div className="inp-err">
                    {institutionData.brochure && (
                      <div className="mb-2 position-relative">
                        <div className="d-flex align-items-center gap-2">
                          <i
                            className="pi pi-file-pdf"
                            style={{ fontSize: "2rem" }}
                          ></i>
                          <span>Brochure uploaded</span>
                          <Button
                            type="button"
                            color="danger"
                            size="sm"
                            onClick={handleBrochureDelete}
                          >
                            ×
                          </Button>
                        </div>
                      </div>
                    )}
                    {brochureFile && !institutionData.brochure && (
                      <div className="mb-2">
                        <small>Selected file: {brochureFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        id="brochure"
                        onChange={e => {
                          if (e.target.files && e.target.files[0]) {
                            setBrochureFile(e.target.files[0])
                          }
                        }}
                        accept=".pdf,.doc,.docx"
                        style={{ flex: 1 }}
                      />
                      {brochureFile &&
                        !isUploadingBrochure &&
                        !institutionData.brochure && (
                          <Button
                            type="button"
                            color="primary"
                            size="sm"
                            onClick={uploadBrochure}
                          >
                            Upload
                          </Button>
                        )}
                    </div>
                    {isUploadingBrochure && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading brochure...
                      </small>
                    )}
                  </div>
                </div>
                {/* <div className="institution-add-inp">
                  <label>Reviews</label>
                  <div className="review-section">
                    <div className="review-input-form">
                      <div className="mb-2">
                        <label htmlFor="reviewerName">Reviewer Name</label>
                        <div className="inp-err">
                          <InputText
                            id="reviewerName"
                            value={currentReview.name}
                            onChange={e =>
                              setCurrentReview({...currentReview, name: e.target.value})
                            }
                            placeholder="Enter Reviewer Name"
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="reviewText">Review</label>
                        <div className="inp-err">
                          <InputText
                            id="reviewText"
                            value={currentReview.review}
                            onChange={e =>
                              setCurrentReview({...currentReview, review: e.target.value})
                            }
                            placeholder="Enter Review"
                          />
                        </div>
                      </div>

                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        className="mt-2"
                        onClick={handleAddReview}
                      >
                        Add Review
                      </Button>
                    </div>

            
                    {institutionData.reviews.length > 0 && (
                      <div className="review-list mt-3">
                        <h6>Added Reviews:</h6>
                        {institutionData.reviews.map((review, index) => (
                          <div key={index} className="review-item p-2 border rounded mb-2">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <strong>{review.name}</strong>
                                <p className="mb-0">{review.review}</p>
                              </div>
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                onClick={() => handleRemoveReview(index)}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div> */}
                {/* <div className="institution-add-inp">
                  <label>Cutoffs</label>
                  <div className="cutoff-section">
                    <div className="cutoff-input-form">
                      <div className="mb-3">
                        <label htmlFor="course">Course</label>
                        <div className="inp-err">
                          <Dropdown
                            id="course"
                            value={currentCutoff.course}
                            onChange={e =>
                              setCurrentCutoff({
                                ...currentCutoff,
                                course: e.value,
                              })
                            }
                            options={courseData || []}
                            optionLabel="name"
                            placeholder="Select Course"
                            filter
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="year">Year</label>
                        <div className="inp-err">
                          <Calendar
                            id="year"
                            value={
                              currentCutoff.year
                                ? new Date(currentCutoff.year, 0)
                                : null
                            }
                            onChange={e => {
                              const selectedYear = e.value
                                ? new Date(e.value).getFullYear()
                                : null
                              setCurrentCutoff({
                                ...currentCutoff,
                                year: selectedYear,
                              })
                            }}
                            view="year"
                            dateFormat="yy"
                            placeholder="Select Year"
                            showIcon
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="quota">Quota</label>
                        <div className="inp-err">
                          <Dropdown
                            id="quota"
                            value={currentCutoff.quota}
                            onChange={e =>
                              setCurrentCutoff({
                                ...currentCutoff,
                                quota: e.value,
                              })
                            }
                            options={quotaOptions}
                            optionLabel="name"
                            placeholder="Select Quota"
                          />
                        </div>
                      </div>

                      <div className="rounds-grid">
                        <div>
                          <label htmlFor="round1">Round 1</label>
                          <div className="inp-err">
                            <InputText
                              id="round1"
                              value={currentCutoff.rounds.round1}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    round1: e.target.value,
                                  },
                                })
                              }
                              placeholder="Round 1 Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="round2">Round 2</label>
                          <div className="inp-err">
                            <InputText
                              id="round2"
                              value={currentCutoff.rounds.round2}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    round2: e.target.value,
                                  },
                                })
                              }
                              placeholder="Round 2 Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="mopUpRound">Mop-Up Round</label>
                          <div className="inp-err">
                            <InputText
                              id="mopUpRound"
                              value={currentCutoff.rounds.mopUpRound}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    mopUpRound: e.target.value,
                                  },
                                })
                              }
                              placeholder="Mop-Up Round Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="strayVacancy">Stray Vacancy</label>
                          <div className="inp-err">
                            <InputText
                              id="strayVacancy"
                              value={currentCutoff.rounds.strayVacancy}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    strayVacancy: e.target.value,
                                  },
                                })
                              }
                              placeholder="Stray Vacancy Cutoff"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="add-cutoff-btn">
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          onClick={handleAddCutoff}
                        >
                          Add Cutoff
                        </Button>
                      </div>
                    </div>

                
                    {institutionData.cutoffs.length > 0 && (
                      <div className="cutoff-list mt-3">
                        <h6>Added Cutoffs:</h6>
                        {institutionData.cutoffs.map((cutoff, index) => {
                          const courseName =
                            courseData.find(c => c.code === cutoff.course)
                              ?.name || "Unknown Course"

                          return (
                            <div
                              key={index}
                              className="cutoff-item p-2 border rounded mb-2"
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Course: {courseName}</strong>
                                  <p className="mb-0">Year: {cutoff.year}</p>
                                  <p className="mb-0">Quota: {cutoff.quota}</p>
                                  <div className="rounds-values">
                                    <small>
                                      Round 1: {cutoff.rounds.round1}
                                    </small>
                                    <small className="ms-2">
                                      Round 2: {cutoff.rounds.round2}
                                    </small>
                                    <small className="ms-2">
                                      Mop-Up: {cutoff.rounds.mopUpRound}
                                    </small>
                                    <small className="ms-2">
                                      Stray: {cutoff.rounds.strayVacancy}
                                    </small>
                                  </div>
                                </div>
                                <Button
                                  type="button"
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleRemoveCutoff(index)}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="institution-add-inp">
                  <label htmlFor="logo">
                    Logo <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    {logoUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={logoUrl}
                          alt={institutionData.logo?.alt || "Institution Logo"}
                          style={{
                            width: "100px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleLogoDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {logoFile && (
                      <div className="mb-2">
                        <small>Selected file: {logoFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="logo"
                        id="logo"
                        accept="image/*"
                        onChange={handleLogoChange}
                      />
                      {logoFile && !isUploading && !logoUrl && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadLogo()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploading && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading logo...
                      </small>
                    )}
                    {!isUploading && logoUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Logo uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="logoAltText">Logo Alt Text</label>
                          <InputText
                            id="logoAltText"
                            name="logoAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the logo"
                            value={institutionData.logo?.alt || ""}
                            onChange={e => {
                              setInstitutionData({
                                ...institutionData,
                                logo: {
                                  url: logoUrl,
                                  alt: e.target.value,
                                },
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="banner">Banner Image</label>
                  <div className="inp-err">
                    {bannerUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={bannerUrl}
                          alt={
                            institutionData.bannerImage?.alt ||
                            "Institution Banner"
                          }
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleBannerDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {bannerFile && (
                      <div className="mb-2">
                        <small>Selected file: {bannerFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="banner"
                        id="banner"
                        accept="image/*"
                        onChange={handleBannerChange}
                      />
                      {bannerFile && !isUploadingBanner && !bannerUrl && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadBanner()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploadingBanner && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading banner...
                      </small>
                    )}
                    {!isUploadingBanner && bannerUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Banner uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="bannerAltText">Banner Alt Text</label>
                          <InputText
                            id="bannerAltText"
                            name="bannerAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the banner"
                            value={institutionData.bannerImage?.alt || ""}
                            onChange={e => {
                              setInstitutionData({
                                ...institutionData,
                                bannerImage: {
                                  url: bannerUrl,
                                  alt: e.target.value,
                                },
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="gallery">
                    Gallery Images <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    {/* Display uploaded images */}
                    {galleryUrls.length > 0 && (
                      <div className="gallery-preview mb-3">
                        <div className="d-flex flex-wrap gap-2">
                          {galleryUrls.map((url, index) => (
                            <div
                              key={index}
                              className="position-relative"
                              style={{ width: "200px" }}
                            >
                              <img
                                src={url}
                                alt={`Gallery ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                className="position-absolute top-0 end-0"
                                style={{ margin: "2px" }}
                                onClick={() => removeGalleryImage(index)}
                              >
                                ×
                              </Button>
                              <div className="mt-2">
                                <InputText
                                  placeholder="Enter alt text for this image"
                                  value={galleryAltTexts[index] || ""}
                                  onChange={e =>
                                    handleGalleryAltTextChange(
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  className="w-100"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Display selected files */}
                    {galleryFiles.length > 0 && (
                      <div className="selected-files mb-2">
                        <h6>Selected Files:</h6>
                        {galleryFiles.map((file, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-1"
                          >
                            <small>{file.name}</small>
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              onClick={() => removeSelectedFile(index)}
                            >
                              Remove
                            </Button>
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="gallery"
                        id="gallery"
                        accept="image/*"
                        multiple
                        onChange={handleGalleryChange}
                      />
                      {galleryFiles.length > 0 && !isUploadingGallery && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={uploadGalleryImages}
                        >
                          Upload Selected
                        </Button>
                      )}
                    </div>
                    {isUploadingGallery && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading gallery images...
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    addInstitute()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddInstitution
